import * as React from "react"
import { CSSProperties } from "react"
import QRCode from "qrcode.react"
import { Button } from "antd"
import { Link, Router } from "../../../../../server/router"
import { downloadQRcodeUrl } from "../../../locations/utils"
import { AntdIconWrap } from "../../../../uiKit/Icons/AntdIconWrap"
import { Color } from "../../../../../constants"
import { Terminal } from "../../../../../graphql/types"
import { PrimaryColor } from "../../../../../constants/colors"

type Props = {
    isWebOrderingEnabled: boolean
    isMobileOrderingEnabled: boolean
    selectedTerminalData: Terminal
}

export const MibSettingsHeader = (props: Props) => {
    if (!props.selectedTerminalData.url) {
        return null
    }
    return (
        <div className={classes.wrap}>
            <div className={classes.textWrap}>
                {props.selectedTerminalData.url && !props.isMobileOrderingEnabled && (
                    <div>
                        <AntdIconWrap style={styles.checkIcon} type="check" />
                        <span>Your site is online at &nbsp;</span>
                        <span>{renderLink(props.selectedTerminalData)}</span>
                        <Button
                            size="small"
                            className={classes.editBtn}
                            onClick={() => Router.push("/make-it-butter-settings/homepageAppearance")}>
                            Edit Appearance
                        </Button>
                    </div>
                )}

                <div>
                    <AntdIconWrap style={styles.circleIcon} type="info-circle" />
                    <span>You can define the items that are being sold online in </span>
                    <Link href="/sales-input/butter">
                        <span style={styles.link}>Management / Sales Input</span>
                    </Link>
                </div>

                <div>
                    <AntdIconWrap style={styles.circleIcon} type="info-circle" />
                    <span>New Online Orders are being sent to your Figure Register.</span>
                </div>
            </div>
            {!props.isMobileOrderingEnabled ? (
                <div className={classes.qrWrap}>{renderQrCode(props.selectedTerminalData, "qr-code")}</div>
            ) : null}
        </div>
    )
}

export const renderLink = (terminal: Terminal) => {
    if (!terminal.url) {
        return null
    }
    return (
        <a href={terminal.url} target="_blank" rel="noreferrer">
            <u>{terminal.url}</u>
        </a>
    )
}

export const renderQrCode = (terminal: Terminal, type: "download-button" | "qr-code") => {
    if (!terminal.url) {
        return null
    }

    const url = terminal.url
    const fileName = `${terminal.name}-QRcode`
    return (
        <div>
            {/* For download purpose */}
            <div
                style={{
                    display: "none",
                }}>
                <QRCode id={url} value={url} level="H" includeMargin={true} size={1024} />
            </div>
            {type === "download-button" ? (
                <a onClick={() => downloadQRcodeUrl(url, fileName.replace(/\s+/g, "_"))}>
                    <Button>Download QR Code</Button>
                </a>
            ) : null}
            {type === "qr-code" ? (
                <a onClick={() => downloadQRcodeUrl(url, fileName.replace(/\s+/g, "_"))}>
                    <QRCode value={url} level="H" includeMargin={true} size={115} />
                </a>
            ) : null}
        </div>
    )
}

const classes = {
    wrap: "mb-2 flex border-b border-gray-200 px-4 pt-4 pb-5",
    textWrap: "flex-1 space-y-4 pt-2",
    qrWrap: "w-[115px]",
    editBtn: "ml-4",
}

const styles: Record<string, CSSProperties> = {
    checkIcon: {
        color: PrimaryColor,
        fontSize: "1.1rem",
        marginRight: "0.5rem",
    },
    circleIcon: {
        fontSize: "1.1rem",
        marginRight: "0.7rem",
    },
    link: {
        textDecoration: "underline",
        color: Color.PrimaryColor,
    },
}
